import { render, staticRenderFns } from "./ContentPreviewHeader.vue?vue&type=template&id=795b5daf&scoped=true&"
import script from "./ContentPreviewHeader.vue?vue&type=script&lang=js&"
export * from "./ContentPreviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContentPreviewHeader.vue?vue&type=style&index=0&id=795b5daf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b5daf",
  null
  
)

export default component.exports